import { Injectable } from "@angular/core";
import { NextPageService } from "@cvx/nextpage";
import { NextPageRoute } from "@cvx/nextpage/public_api";
import { BehaviorSubject, map, Observable, combineLatest } from "rxjs";
import { LoggedUserService } from "./common/logged-user.service";
import { RoleNames } from "../utils/role-names";

@Injectable({
  providedIn: "root",
})
export class RoutesService {
  private allowedPages: { pageName: string; subPageName: string }[] = [];
  private filteredRoutes: NextPageRoute[] = [];

  filteredRoutesLoaded = new BehaviorSubject<boolean>(false);

  constructor(
    private NP: NextPageService,
    private loggedUserService: LoggedUserService
  ) {}

  setFilteredRoutes(routes: NextPageRoute[]) {
    this.filteredRoutes = routes;
  }

  getFilteredRoutes(): NextPageRoute[] {
    return this.filteredRoutes;
  }

  public filterRoutes(routes: NextPageRoute[]): Observable<NextPageRoute[]> {
    return combineLatest([
      this.loggedUserService.getLoggedUserRoleFromToken(),
      this.loggedUserService.getLoggedUserFacilityName(),
    ]).pipe(
      map(([role, facility]) => {
        let filteredRoutes = [...routes];

        // Filter admin-only routes for regular users
        if (role == RoleNames.ERT_USER) {
          filteredRoutes = filteredRoutes.filter((route) => {
            if (
              route.data &&
              route.data.isAdminOnly &&
              route.data.isAdminOnly == true
            ) {
              return false;
            } else {
              return true;
            }
          });
        }

        // Hide KR-998 route if user is not in Pascagoula facility
        if (facility !== "Pascagoula") {
          filteredRoutes = filteredRoutes.filter((route) => {
            return route.path !== "ert-kr998";
          });
        }

        return filteredRoutes;
      })
    );
  }

  public filterRoutesForMenu(routes: NextPageRoute[]) {
    return this.filterRoutes(routes).subscribe((filteredRoutes) => {
      routes = filteredRoutes;
      this.NP.setOption("navigationRoutes", routes);
      this.NP.UI.setNavigation(routes);
      this.NP.options.navigationRoutes = routes;
      this.NP.UI.options.navigationRoutes = routes;
      this.NP.buildMenuStructure();
      this.filteredRoutesLoaded.next(true);
    });
  }
}
